import { useEffect } from "react";
import { useAuthStore } from "@/features/auth";
import { getUserByToken } from "../api";
import { useLoadingAppStore } from "@/shared/model";
import { useNavigate, useLocation } from "react-router-dom";

export const useFetchUser = () => {
  const { user, isAuthorized, setIsAuthorization, setUser, logout } = useAuthStore(
    (state) => state
  );

  const { setLoading } = useLoadingAppStore();
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthPage = ["/login", "/register", "/forgot"].includes(location.pathname);

  useEffect(() => {
    if (!token && !isAuthPage) {
      navigate("/login", { replace: true });
    }
  }, [token, isAuthPage, navigate]);

  useEffect(() => {
    if (!token || user || isAuthPage) return; 

    setLoading(true);
    setIsAuthorization();

    (async () => {
      try {
        const res = await getUserByToken(token);

        if (res?.result) {
          setUser(res.result);
        } else {
          logout();
          if (!isAuthPage) {
            navigate("/login", { replace: true });
          }
        }
      } catch (e) {
        console.error("Ошибка запроса пользователя:", e);
        logout();
        if (!isAuthPage) {
          navigate("/login", { replace: true });
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [token, user, isAuthPage, navigate, logout, setLoading, setIsAuthorization]);
};